import React from "react";

const OfferPage = ({
  employment,
  offerSeconds,
  setAddBankSource,
  setDisburseBankError,
  setDisburseBankSuccess,
  setDisburseBank,
  setScreen,
  panProfile,
  getBank,
  selectedBankId,
  formatLoanAmount,
  formatCountdown,
  OfferHeroArt,
}) => {
  return (
    <section className="fw-screen fw-screen--offer fw-fade">
      <div
        className="fw-offer__bg"
        aria-hidden="true"
      />

      <div className="fw-offer__content">
        <header className="fw-offer__head">
          <span className="fw-offer__badge">
            Loan Approved
          </span>

          <h1 className="fw-offer__title">
            Congratulations!
          </h1>

          <p className="fw-offer__label">
            Your approved loan amount
          </p>

          <div className="fw-offer__amount-card">
            <strong className="fw-offer__amount">
              {formatLoanAmount(
                employment.loanAmount
              )}
            </strong>
          </div>
        </header>

        <div className="fw-offer__hero">
          <OfferHeroArt />
        </div>

        <div
          className={`fw-offer__meta ${
            offerSeconds <= 120
              ? "is-urgent"
              : ""
          }`}
        >
          <p>
            Exclusive Offer Just for You!
          </p>

          <span>
            Offer expires in
          </span>

          <div
            className="fw-offer__timer"
            aria-live="polite"
          >
            {formatCountdown(
              offerSeconds
            )
              .split(":")
              .map((part, index) => (
                <React.Fragment
                  key={`${index}-${part}`}
                >
                  {index > 0 && (
                    <em>:</em>
                  )}

                  <b>{part}</b>
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>

      <div className="fw-offer__action">
        <button
          type="button"
          className={`fw-btn fw-btn--dark fw-btn--full fw-offer__cta ${
            offerSeconds === 0
              ? "is-ready"
              : ""
          }`}
          disabled={
            offerSeconds > 0
          }
          onClick={() => {
            setAddBankSource("offer");

            setDisburseBankError("");

            setDisburseBankSuccess("");

            setDisburseBank((prev) => ({
              ...prev,
              holderName:
                prev.holderName ||
                panProfile?.name ||
                "",
              bankName:
                prev.bankName ||
                getBank(
                  selectedBankId
                ).name,
            }));

            setScreen(
              "/apply-new/addBankDetails"
            );
          }}
        >
          {offerSeconds > 0
            ? "Withdraw Funds"
            : "Withdraw Funds Now"}
        </button>

        {offerSeconds > 0 && (
          <p className="fw-offer__cta-note">
            Button unlocks when timer ends
          </p>
        )}
      </div>
    </section>
  );
};

export default OfferPage;